import React from "react";
import { Route, Routes as ReactRoutes } from "react-router";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";

const Routes = () => {
    return (
        <ReactRoutes>
            <Route path='/' element={<Home />} />
            <Route path='*' element={<NotFound />} />
        </ReactRoutes>
    );
};

export default Routes;
